module.exports = __WEBPACK_EXTERNAL_MODULE_158__;


//////////////////
// WEBPACK FOOTER
// external "node-fetch"
// module id = 158
// module chunks = 0